// extracted by mini-css-extract-plugin
export var isNoDecoration = "linkButton-module--is-no-decoration--c7cd2";
export var linkButton = "linkButton-module--linkButton--58732";